import axios from 'axios';

axios.interceptors.request.use((config) => {
    // config.headers['Frontend-Hostname'] = window.location.hostname
    return config;
});